/* A declined age check keeps the existing modal and background lock in place. */
document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-cbd-age-decline]');
  if (!button) return;
  const gate = button.closest('[data-crysalidas-age-gate]');
  if (!gate) return;
  const message = gate.querySelector('.crysalidas-age-gate__message');
  const accept = gate.querySelector('[data-crysalidas-age-accept]');
  if (!message || !accept) return;
  const declined = button.dataset.declined === 'true';
  if (!declined) {
    button.dataset.originalMessage = message.textContent;
    message.textContent = 'Este contenido está reservado a mayores de 18 años. Puedes cerrar esta pestaña.';
    accept.hidden = true;
    accept.disabled = true;
    button.textContent = 'Revisar mi respuesta';
  } else {
    message.textContent = button.dataset.originalMessage;
    accept.hidden = false;
    accept.disabled = false;
    button.textContent = 'No, salir';
  }
  button.dataset.declined = String(!declined);
  button.focus();
});
